import { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import BSNavbar from "../../component/Navbar/Navbar";
import { FaTimes } from 'react-icons/fa';
import ProfessorCommentItem from "../../component/CommentItem/ProfessorCommentItem";
import { FaSearch } from 'react-icons/fa'
import FadeLoader from "react-spinners/FadeLoader"; 
import { Pagination, Form, Dropdown, Badge } from "react-bootstrap"; 
import { BsArrowRightCircleFill } from 'react-icons/bs';
import { update } from "../../features/searchKeyword/searchKeyword";
import { searchKeyword } from "../../features/searchKeyword/searchKeyword";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import './ProfessorComment.css';

const search_api_url = process.env.REACT_APP_API_URL + "/professor_reviews/reviews/all?professor_name=";
const page_api_url = process.env.REACT_APP_API_URL + "/professor_reviews/reviews/all?page=";
const college_api_url = process.env.REACT_APP_API_URL + "/professor_reviews/colleges";
const institute_api_url = process.env.REACT_APP_API_URL + "/professor_reviews/institutes";
//const max_page_api_url = process.env.REACT_APP_API_URL + "/comments/pages";

const ProfessorComment = () => {
    const [comment, setComment] = useState([]);
    const [nowPage, setNowPage] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [localSearch, setLocalSearch] = useState('');
    const searchKey = useSelector(searchKeyword);
    const [searchTrigger, setSearchTrigger] = useState(false);
    const [loading, setLoading] = useState(false);
    const windowWidth = useSelector(selectWindowWidth);
    const dispatch = useDispatch();

    // college 
    const [CollegeLocalSearch, setCollegeLocalSearch] = useState('');
    const [collegeList, setCollegeList] = useState([]);
    const [CollegeShowDropdown, setCollegeShowDropdown] = useState(false);
    const CollegeSearchBarRef = useRef(null);
    const [collegeId, setCollegeId] = useState(null);

    // institute
    const [InstituteLocalSearch, setInstituteLocalSearch] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [InstituteShowDropdown, setInstituteShowDropdown] = useState(false);
    const [instituteId, setInstituteId] = useState([]);

    const searchPageComments = async (page) => {
      setLoading(true);
      const response = await fetch(`${page_api_url}${page}`).then(res => res.json());
      console.log(response);
      if (!response || response.length === 0 || !response.reviews) {
        setLoading(false);
        return;
      }
      setComment(response.reviews);
      buildInstituteMap(response.reviews);
      setLoading(false);
      setMaxPage(response.total_pages);
      setNowPage(response.current_page);
    }

    const [instituteMap, setInstituteMap] = useState({});
  
    // use searchKey to search comments
    const searchComments = async (page) => {
      setLoading(true);
      const response = await fetch(`${search_api_url}${searchKey}`).then(res => res.json());
      if (!response.reviews || response.length === 0) {
        alert('搜尋不到，請嘗試其他關鍵字><');
        setLoading(false);
        return;
      }
      if (searchKey.length > 0) {
        const reversed = response.reviews.reverse();
        setComment(reversed);
      } else {
        setComment(response.reviews);
        buildInstituteMap(response.reviews);
      }
      setMaxPage(response.total_pages);
      setNowPage(response.current_page);
      setLoading(false);
    }

    useEffect(() => {
      const controller = new AbortController();

      if (searchKey.length > 0) {
        clearCollegeInstituteFilters();
      }
  
      searchComments(0);
      setLocalSearch(searchKey);
  
      return () => controller.abort();
    }, [searchTrigger, searchKey])
  
    useEffect(() => {
      const controller = new AbortController();
    
      if (searchKey.length === 0) {
        searchPageComments(nowPage);
    }
    
      return () => controller.abort();
    }, [nowPage])

    const clearCollegeInstituteFilters = () => {
      setCollegeLocalSearch('');
      setCollegeId(null);
      setCollegeShowDropdown(false);

      setInstituteLocalSearch('');
      setInstituteId([]);
      setInstituteList([]);
      setInstituteShowDropdown(false);
    };

    const handleSearch = () => {
      dispatch(update(localSearch));
      setSearchTrigger(!searchTrigger);
    }
  
    const handleSubmit = (e) => {
      e.preventDefault();
      handleSearch();
    }

    // college
    const handleCollegeFocus = async () => {
      try {
        const response = await fetch(college_api_url);
        const data = await response.json();
        setCollegeList(data);
        setCollegeShowDropdown(true);
      } catch (error) {
        console.error("Failed to fetch colleges:", error);
      }
    };
    
    const handleCollegeSelect = async(collegeName, id) => {
      setLocalSearch('');
      dispatch(update(''));

      setCollegeLocalSearch(collegeName);
      setCollegeShowDropdown(false);
      setCollegeId(id);
      setInstituteLocalSearch('');
      setInstituteId([]);
      await fetchProfessorReviews(id, instituteId);
    };

    const handleCollegeRemove = (e) => {
      e.stopPropagation();
      setCollegeLocalSearch('');
      setCollegeId(null);
      setInstituteLocalSearch('');
      setInstituteId([]);
      setCollegeShowDropdown(false);
      searchPageComments(nowPage);
    };

    // institute
    const handleInstituteFocus = async () => {
      if (!collegeId) {
        console.error("College ID is not set.");
        alert("請先選擇學院！");
        return;
      }
    
      try {
        const url = `${institute_api_url}/${collegeId}`;
        console.log("Fetching institutes from:", url);
    
        const response = await fetch(url);
        const data = await response.json();
        setInstituteList(data);
        setInstituteShowDropdown(true);
      } catch (error) {
        console.error("Failed to fetch institutes:", error);
      }
    };

    const handleInstituteSelect = async (id) => {
      setLocalSearch('');
      dispatch(update(''));
      setInstituteId((prevIds) => {
        const updatedIds = prevIds.includes(id)
          ? prevIds.filter((selectedId) => selectedId !== id)
          : [...prevIds, id]; 
    
        fetchProfessorReviews(collegeId, updatedIds);
    
        return updatedIds;
      });
    };

    const handleInstituteRemove = (e, id) => {
      e.stopPropagation();
      setInstituteId((prevIds) => prevIds.filter((instituteId) => instituteId !== id));
      setInstituteShowDropdown(false);
      fetchProfessorReviews(collegeId, instituteId.filter((instituteId) => instituteId !== id));
    };

    // Fetch professor reviews for the selected college and institutes
    const fetchProfessorReviews = async (collegeId, instituteIds) => {
      if (!collegeId) {
        console.error("缺少學院");
        return;
      }
      let url = `${process.env.REACT_APP_API_URL}/professor_reviews/reviews/all?college_id=${collegeId}&institute_id=${instituteIds.join(",")}`;
      
      if (instituteIds.length === 0) {
        url = `${process.env.REACT_APP_API_URL}/professor_reviews/reviews/all?college_id=${collegeId}`;
      }
      try {
        const response = await fetch(url);
        const data = await response.json();
    
        if (!data || data.length === 0) {
          alert('搜尋不到，請嘗試其他關鍵字><');
          return;
        }
    
        setComment(data.reviews);
        buildInstituteMap(data.reviews);
        setMaxPage(data.total_pages);
        setNowPage(data.current_page);
      } catch (error) {
        console.error("獲取心得失敗:", error);
      }
    };

    const buildInstituteMap = async (reviews) => {
  if (!reviews || reviews.length === 0) {
    setInstituteMap({});
    return;
  }

  const uniqueCollegeIds = [...new Set(reviews.map((r) => r.college_id).filter(Boolean))];

      try {
        const results = await Promise.all(
          uniqueCollegeIds.map(async (collegeId) => {
            const response = await fetch(`${institute_api_url}/${collegeId}`);
            const data = await response.json();
            return data;
          })
        );

        const flatInstitutes = results.flat();

        const map = flatInstitutes.reduce((acc, institute) => {
          acc[institute.id] = institute.name;
          return acc;
        }, {});

        setInstituteMap(map);
      } catch (error) {
        console.error("建立 institute map 失敗:", error);
      }
    };

    if (loading) {
      return (
        <div style={{ background: '#dfd8cd', height: '100vh' }}>
          <BSNavbar bg={'#dfd8cd'} />
          <FadeLoader
            color="#4b3615"
            loading={true}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
            style={{ position: 'absolute', top: '50%', left: '50%' }}
          />
        </div>
      )
    } else {
      return (
        <div style={{ background: '#dfd8cd', minHeight: '100vh', paddingBottom: '20px' }}>
          <BSNavbar bg={'#dfd8cd'} />
          <div
            style={{
              position: "relative",
              width: windowWidth < 900 ? "90%" : "80%",
              margin: "0 auto",
            }}
          >
            <Dropdown
              show={CollegeShowDropdown}
              onToggle={(isOpen) => setCollegeShowDropdown(isOpen)}
            >
              <Dropdown.Toggle
                id="college-dropdown"
                onClick={handleCollegeFocus}
                className="dropdown-toggle-custom"
              >
                <FaSearch className="dropdown-icon" size={20} />
                <span className="dropdown-text">
                {CollegeLocalSearch ? (
                  <Badge bg="success" className="me-2 position-relative" style={{ paddingRight: '20px' }}>
                    {CollegeLocalSearch}
                    <FaTimes
                      size={14}
                      className="position-absolute top-0 end-0 m-1"
                      onClick={(e) => handleCollegeRemove(e)}
                    />
                  </Badge>
                ) : (
                  "選擇學院"
                )}
                </span>
                <div className="dropdown-arrow">
                <span>&#9662;</span> 
              </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                
                className="dropdown-menu-custom"
              >
                {collegeList.map((college) => (
                  <Dropdown.Item
                    key={college.id}
                    className="dropdown-item-custom"
                    onClick={() => handleCollegeSelect(college.name, college.id)}
                  >
                    {college.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div style={{ margin: '25px 0' }}></div>
          <div
            style={{
              position: "relative",
              width: windowWidth < 900 ? "90%" : "80%",
              margin: "0 auto",
            }}
          >
            <Dropdown
              show={InstituteShowDropdown}
              onToggle={(isOpen) => setInstituteShowDropdown(isOpen)}
            >
              <Dropdown.Toggle
                id="institute-dropdown"
                onClick={handleInstituteFocus}
                className="dropdown-toggle-custom"
              >
                <FaSearch className="dropdown-icon" size={20} />
                <span className="dropdown-text">
                {instituteId.length > 0
                ? instituteList
                    .filter((institute) => instituteId.includes(institute.id))
                    .map((institute) => (
                      <Badge key={institute.id} bg="warning" text="dark" className="me-2 position-relative" style={{ paddingRight: '20px' }}>
                        {institute.name}
                        <FaTimes
                          size={14}
                          className="position-absolute top-0 end-0 m-1 text-dark"
                          onClick={(e) => handleInstituteRemove(e, institute.id)}
                        />
                      </Badge>
                    ))
                : "選擇系所"}
                </span>
                <div className="dropdown-arrow">
                  <span>&#9662;</span>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                
                className="dropdown-menu-custom"
              >
                {instituteList.map((institute) => (
                  <Dropdown.Item
                  key={institute.id}
                  className={`dropdown-item-custom ${
                    instituteId.includes(institute.id) ? "selected" : ""
                  }`}
                  onClick={() => handleInstituteSelect(institute.id)}
                >
                  {institute.name}{" "}
                  {instituteId.includes(institute.id) && <span>&#10003;</span>}
                </Dropdown.Item>
                
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div style={{ margin: '15px 0' }}></div>
          
          <Form ref={CollegeSearchBarRef} onSubmit={handleSubmit} className='comment-input ms-auto me-auto mb-3 mt-4'
            style={{
              width: windowWidth < 900 ? '90%' : '80%',
              height: '50px'
            }}>
            <FaSearch size={20} />
            <Form.Control
              style={{ fontSize: '20px' }}
              placeholder="教授名稱"
              autoFocus
              onChange={(e) => setLocalSearch(e.target.value)}
              className="comment-search-tag"
              value={localSearch}
            />
            <BsArrowRightCircleFill
              size={30}
              className="me-2 comment-send-icon"
              onClick={handleSearch}
              type="submit"
            />
          </Form>

          {(comment || []).map((ele, id) => (
            <ProfessorCommentItem
              ele={{
                ...ele,
                institute_name: instituteMap[ele.institute_id] || ""
              }}
              key={id}
              variant="all-comment"
            />
          ))}
  
          {(maxPage >= 1) && (
          <div style={{ display: 'flex' }}>
            <Pagination style={{ margin: 'auto', marginBottom: '30px', marginTop: '20px' }}>
              <Pagination.First 
                onClick={() => setNowPage(0)} 
                disabled={nowPage === 0}
              />
              <Pagination.Prev 
                onClick={() => setNowPage(nowPage - 1)} 
                disabled={nowPage === 0}
              />
              {nowPage > 1 && (
                <Pagination.Item onClick={() => setNowPage(0)}>
                  1
                </Pagination.Item>
              )}
              {nowPage > 2 && <Pagination.Ellipsis disabled />}
              {nowPage > 0 && (
                <Pagination.Item onClick={() => setNowPage(nowPage - 1)}>
                  {nowPage}
                </Pagination.Item>
              )}
              <Pagination.Item active>
                {nowPage + 1}
              </Pagination.Item>
              
              {nowPage < maxPage - 2 && (
                <Pagination.Item onClick={() => setNowPage(nowPage + 1)}>
                  {nowPage + 2}
                </Pagination.Item>
              )}
              {nowPage < maxPage - 2 && <Pagination.Ellipsis disabled />}
              {nowPage < maxPage - 1 && (
                <Pagination.Item onClick={() => setNowPage(maxPage - 1)}>
                  {maxPage}
                </Pagination.Item>
              )}

              <Pagination.Next 
                onClick={() => setNowPage(nowPage + 1)} 
                disabled={nowPage === maxPage - 1}
              />
              <Pagination.Last 
                onClick={() => setNowPage(maxPage - 1)} 
                disabled={nowPage === maxPage - 1}
              />
            </Pagination>
          </div>
        )}

        </div >
      );
    }
  }
  
  export default ProfessorComment;